import React, { ReactNode } from "react";
import { Checkbox, CheckboxProps, FormControlLabel, FormControlLabelProps } from "@mui/material";
import { useField } from "formik";
import xor from "lodash/xor";

export interface CheckboxFormikProps
  extends Omit<CheckboxProps, "name" | "onChange" | "onBlur" | "error"> {
  name: string;
  label?: ReactNode;
  labelPlacement?: FormControlLabelProps["labelPlacement"];
  status?: boolean;
}

const CheckboxField = ({
  name,
  label,
  value,
  labelPlacement,
  status,
  ...props
}: CheckboxFormikProps) => {
  const [field, , helpers] = useField(name);
  const { setValue } = helpers;

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      if (Array.isArray(field.value)) {
          let values = xor(field.value, [value]).slice()
          values = values.filter(el => el)
          if (values.length === 0) {
              setValue([])
          } else {
              setValue(xor(field.value, [value]))
          }
      } else {
          setValue(event.target.checked ?? false);
      }
  }

  return (
    <FormControlLabel
      style={{ display: "grid", gridTemplateColumns: "0fr 1fr", paddingTop: '5px', paddingBottom: '5px' }}
      onBlur={field.onBlur}
      control={
        <Checkbox
          disabled={status}
          checked={Array.isArray(field.value) ? field.value.includes(value) : field.value}
          // onChange={Array.isArray(field.value) ? () => onChange() : field.onChange}
          onChange={onChange}
          name={name}
        />
      }
      label={label}
      labelPlacement={labelPlacement}
      disabled={status}
      required={props?.required}
    />
  );
};

export default CheckboxField;
